export const DEFAULT_LOCALE = "en-US";
export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

// Navigation Configuration
export const NAVIGATION_CONFIG = {
  IDENTITY: {
    TITLE: "Document Tabular AI Reviewer",
    HREF: "#",
    LOGO_ALT: "Document Tabular AI Reviewer"
  },
  UTILITIES: {
    WIKI: {
      TEXT: "wiki",
      HREF: "https://w.amazon.com/bin/view/Legal/DBALegalTech/",
      EXTERNAL_LABEL: " (opens in a new tab)"
    },
    NOTIFICATIONS: {
      TITLE: "Notifications",
      ARIA_LABEL: "Notifications (unread)"
    },
    SETTINGS: {
      TITLE: "Settings",
      ARIA_LABEL: "Settings",
      ITEMS: [
        { ID: "settings-org", TEXT: "Organizational settings" },
        { ID: "settings-project", TEXT: "Project settings" }
      ]
    },
    USER_MENU: {
      ITEMS: [
        { ID: "profile", TEXT: "Profile" },
        { ID: "preferences", TEXT: "Preferences" },
        { ID: "security", TEXT: "Security" },
        {
          ID: "support-group",
          TEXT: "Support",
          ITEMS: [
            {
              ID: "documentation",
              TEXT: "Documentation",
              HREF: "#",
              EXTERNAL_LABEL: " (opens in new tab)"
            },
            { ID: "support", TEXT: "Support" },
            {
              ID: "feedback",
              TEXT: "Feedback", 
              HREF: "#",
              EXTERNAL_LABEL: " (opens in new tab)"
            }
          ]
        },
        { ID: "signout", TEXT: "Sign out" }
      ]
    },
    SIGN_IN: {
      TEXT: "Sign In"
    }
  },
  USER_DISPLAY: {
    DEFAULT_NAME: "Guest User",
    DEFAULT_EMAIL: "Please sign in",
    FALLBACK_NAME: "Amazon User"
  }
};

// Environment Detection
export const ENVIRONMENT = {
  isLocal: (): boolean => {
    const hostname = window.location.hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1';
  }
};
